import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  getFilteredMagazines,
  getTranslation
} from '@/store/getters'
import {
  fetchMagazines,
  addMagazine,
  filterMagazines,
  deleteMagazine,
  closeAlert,
  setPages,
  setHeaderMode,
} from '@/store/actions'

import styles from './styles.scss'

/** Components */
import SearchBox from '@/components/SearchBox'
import MagazineModal from './components/MagazineModal'
import MagazineCard from './components/MagazineCard'
import TemplateCard from './components/TemplateCard'
import MagazineCreateNewButton from "./components/MagazineCreateNewButton";

class DashboardComponent extends Component {
  state = {
    navigation: 'magazines',
    search: '',
    key: Math.random()
  }

  componentDidMount() {
    const { fetchMagazines, setHeaderMode } = this.props

    fetchMagazines()
    setHeaderMode('normal')

    setTimeout(() => {
      if (!document.getElementById('office-script-id')) {
        let s = document.createElement('script')
        s.type = 'text/javascript'
        s.id = 'office-script-id'
        s.src = 'https://office.builderall.com/internacional/public/mix/web-components/js/wc-tutorial-video.js'
        try {
          var headID = document.getElementsByTagName('head')[0]
          headID.appendChild(s)
        } catch (e) {
        }
      }
    }, 3000)
  }

  handleNavigation = event => {
    event.preventDefault()
    let value = event.currentTarget.getAttribute('href')

    this.setState({ navigation: value })
    this.setState({ key: Math.random() })
  }

  handleMagazineFilter = filter => this.props.filterMagazines(filter)

  handleMagazineSearch = search => {
    const { magazines } = this.props

    const filteredMagazines = magazines.filter(i => {
      return (
        i.title.toLowerCase().indexOf(search.toLowerCase()) !== -1 ||
        i.description.toLowerCase().indexOf(search.toLowerCase()) !== -1
      )
    })

    return filteredMagazines
  }

  openModal = () => this.setState({ isOpened: true })
  closeModal = () => this.setState({ isOpened: false })

  render() {
    const { search, isOpened } = this.state
    let { translation, magazines } = this.props

    magazines = this.handleMagazineSearch(search)

    return (
      <builderall-appshell token={localStorage.getItem('__office_token__')} tool="magazine-builder">
        <div className='ba-app-content'>
          <builderall-banner
            title='Builderall Plume'
            subtitle={translation('general-welcome-magazine')}
            description={translation('alert-box-message-dashboard')}
          />
          <div className='ba-app-wrapper ba-gp-1'>
            <div className='ba-sidebar'>
              <ul className='ba-nav'>
                <li className='ba-nav-item'>
                  <a href='magazines' className={'ba-link' + (this.state.navigation === 'magazines' ? ' ba-is-active' : '')}
                    onClick={this.handleNavigation}>
                    <builderall-icon code='magazine-builder'></builderall-icon>
                    <span className='ba-title'>{translation('general-your-magazines')}</span>
                  </a>
                </li>
                <li className='ba-nav-item'>
                  <a href='templates' className={'ba-link' + (this.state.navigation === 'templates' ? ' ba-is-active' : '')}
                    onClick={this.handleNavigation}>
                    <builderall-icon code='81f2'></builderall-icon>
                    <span className='ba-title'>{translation('general-all-templates')}</span>
                  </a>
                </li>
              </ul>
              <div className='ba-bottom'>
                <ul className='ba-bottom-list'>
                  <li>
                    <builderall-help></builderall-help>
                  </li>
                </ul>
              </div>
            </div>

            <section className='ba-container'>
              <div className='ba-card'>
                <div className='ba-top'>
                  <span className='ba-title'>
                    {this.state.navigation === 'magazines' ? translation('magazine-title') : translation('general-all-templates')}
                  </span>
                  <div className='ba-box-items ba-flex ba-gp-1'>
                    {this.state.navigation === 'magazines' && (
                      <SearchBox
                        handleChange={search => this.setState({ search })}
                        label={translation('dashboard-search')}
                      />
                    )}

                    <MagazineCreateNewButton />
                  </div>
                </div>

                <div className='ba-content ba-mg-t-2'>
                  <div className={
                    this.state.navigation === 'magazines' ?
                      'ba-flex ba-f-wrap ba-gp-1' : styles['ba-none']
                  }>
                    {magazines.map((magazine, index) => (
                      <MagazineCard
                        key={magazine.id}
                        magazine={magazine}
                        index={index}
                        onDeleteItem={this.onDeleteMagazine}
                        onDuplicateItem={this.onDuplicateMagazine}
                      />
                    ))}
                  </div>
                  <div className={
                    this.state.navigation === 'templates' ?
                      'ba-flex ba-f-wrap ba-gp-1' : styles['ba-none']
                  }>
                    <TemplateCard search={search} />
                  </div>
                </div>
              </div>

            </section>
            <div className='ba-footer'>
              <builderall-footer></builderall-footer>
            </div>
            <MagazineModal show={isOpened} handleClose={this.closeModal} />
          </div>
        </div>
      </builderall-appshell>
    )
  }

  createTutorialButton(translation) {
    // if ( !document.getElementById( 'office-script-id' ) ) {
    //   return (
    //     <btn-overview key={this.state.key}
    //       data-btn-text={ translation( 'magazine-overview' ) }
    //       data-box-opened="1"
    //       data-box-description={ translation( 'magazine-overview-description' ) }
    //       data-box-button-link={ translation( 'magazine-overview-url-more' ) }
    //       data-box-button-text={ translation( 'magazine-overview-more-info' ) }
    //       data-box-thumb={ 'https://storage.builderall.com//franquias/2/987/editor-html/9096463.png' }
    //       data-modal-close-text={ translation( 'magazine-overview-close-fullscreen' ) }
    //       data-modal-video-url={ translation( 'magazine-overview-url-video' ) }
    //     >
    //     </btn-overview>
    //   )
    // }
  }
}

const mapStateToProps = state => {
  const { filter } = state.magazines
  const magazines = getFilteredMagazines(state, filter)
  const translation = getTranslation(state)
  return { magazines, translation }
}
export default connect(
  mapStateToProps,
  {
    fetchMagazines,
    addMagazine,
    filterMagazines,
    deleteMagazine,
    closeAlert,
    setPages,
    setHeaderMode,
  }
)(DashboardComponent)



// WEBPACK FOOTER //
// ./src/pages/Dashboard/index.js